export const CANNOT_ADD_KOPR_FEEDBACK_PRODUCTION_ALREADY_CLOSED_ERR_MSG =
	'Unable to add notice for document cus it is already resolved.';
